import { useEffect } from "react";
import { toast } from "react-toastify";
import { useFetch } from "utils/hooks";

import { useQuery } from "@tanstack/react-query";

import { CacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { AvailableDatesApiResponse } from "./type.ts";

type useAvailableDatesParams = {
  hallId?: string | null;
};

const useAvailableDates = (params: useAvailableDatesParams) => {
  const { hallId } = params;

  const fetch = useFetch();

  const { data, isFetching, isError } = useQuery<
    AvailableDatesApiResponse | null,
    Error,
    AvailableDatesApiResponse
  >({
    queryKey: ["available-dates"],
    enabled: !!hallId,
    queryFn: () =>
      fetch<AvailableDatesApiResponse>(`${Urls.AvailableDates}`, {
        method: "GET",
        slug: {
          hallId,
        },
      }),
    gcTime: CacheTime,
    staleTime: CacheTime,
  });

  useEffect(() => {
    if (isError) {
      toast.error("Error getting available dates");
    }
  }, [isError]);

  return {
    availableDates: data?.bookingDates || [],
    isFetching,
  };
};

export default useAvailableDates;
